import { useState, useEffect } from "react";
import { useModal } from "../../hooks";
import LavorisService from "../../services/LavorisService";
import EditRRHHResult from "../others/userModule/RRHHResult/editRRHHResult";
import AddRRHHResult from "../others/userModule/RRHHResult/addRRHHResult";
import InfiniteTable from "../../components/others/InfiniteTableComponent/IntiniteTableComponent";
import { getUserRolesTableColumns } from "./userRolesTableColumns";

const ADD_RRHH_RESULT_MODAL = "addRRHH_RESULTModal";
const EDIT_RRHH_RESULT_MODAL = "editRRHH_RESULTModal";

const RRHHResult = () => {
  const LavorisInstance = LavorisService.getInstance();
  // useStates
  const [tableLoading, setTableLoading] = useState(true);
  const { openModal, closeModal, isActive } = useModal();
  const [RRHH_RESULTs, setRRHH_RESULTs] = useState<any[]>([]);
  const [RRHH_RESULT, setRRHH_RESULT] = useState<any>(null);


  const getItems = async () => {
    setTableLoading(true);
    try {
      const response = await LavorisInstance.User.findUsersByRoleAlias("RRHH_RESULT");
      setRRHH_RESULTs(response);
    } catch (error) {
      console.log(error);
    } finally {
      setTableLoading(false);
    }
  };
  useEffect(() => {
    const getData = async () => {
      await getItems();
    };
    getData();
  }, []);

  // Configuración de columnas para la tabla
  const requestedTurnsColumns = getUserRolesTableColumns((rowData) => {
    openModal(EDIT_RRHH_RESULT_MODAL, rowData.id);
    setRRHH_RESULT(rowData);
  });

  return (
    <>
      <div className="custom-header mt-sm-4 mt-0 pt-2">
        <div className="header-controls">
          {/* Search Section */}
          <div className="search-section">
          </div>

          {/* Actions Section */}
          <div className="actions-section">
            <button
              type="button"
              className="add-btn"
              onClick={() => {
                openModal(ADD_RRHH_RESULT_MODAL);
              }}
              title="Agregar"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M8 3.333v9.334M3.333 8h9.334"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <span className="btn-text">Agregar</span>
            </button>
          </div>
        </div>
      </div>

      <InfiniteTable
        data={RRHH_RESULTs}
        columns={requestedTurnsColumns}
        loading={tableLoading}
        hasMore={false}
        onLoadMore={() => { }}
        height={300}
        emptyMessage="Momentáneamente no hay datos para mostrar"
        loadingMessage={RRHH_RESULTs.length === 0 ? "Cargando datos..." : "Buscando más datos..."}
        striped
        hover
        bordered
      />


      {isActive(ADD_RRHH_RESULT_MODAL) && (
        <AddRRHHResult
          show
          urlTittle={ADD_RRHH_RESULT_MODAL}
          onClose={() => closeModal(ADD_RRHH_RESULT_MODAL)}
          modalTittle="Agregar RRHH Resultados"
          tableLoading={getItems}
        />
      )}

      {isActive(EDIT_RRHH_RESULT_MODAL) && (
        <EditRRHHResult
          show
          urlTittle={EDIT_RRHH_RESULT_MODAL}
          onClose={() => closeModal(EDIT_RRHH_RESULT_MODAL)}
          modalTittle="Editar RRHH Resultados"
          data={RRHH_RESULT}
          tableLoading={getItems}
        />
      )}
    </>
  );
};

export default RRHHResult;
